import { useState, useEffect } from 'react';
import { subscribe } from '@/lib/firebase';
import { mappingService } from '../services/mappingService';

export function useCategoryMappings(householdId) {
  const [mappings, setMappings] = useState({});

  useEffect(() => {
    if (!householdId) return;
    const unsub = subscribe(
      `households/${householdId}/budget/categoryMappings`,
      (val) => setMappings(val || {})
    );
    return () => unsub();
  }, [householdId]);

  const updateMappings = async (newMappings) => {
    const merged = { ...mappings, ...newMappings };
    setMappings(merged);
    await mappingService.save(householdId, merged);
  };

  const deleteMapping = async (key) => {
    const updated = { ...mappings };
    delete updated[key];
    setMappings(updated);
    await mappingService.save(householdId, updated);
  };

  return { mappings, updateMappings, deleteMapping };
}
